import React from "react"
import Banner from "./banner"
import Divider from "./divider"

interface WidgetLoaderProps {
  data: any
  locale?: string
}

const WidgetLoader = ({ data, locale }: WidgetLoaderProps) => {
  switch (data.strapi_component) {
    case "elements.banner":
      return <Banner data={data} locale={locale} />
    case "elements.divider":
      return <Divider data={data} locale={locale} />
    default:
      return <></>
  }
}

export default WidgetLoader
